export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15029.1eab188b.jpg";